import { createFileRoute } from '@tanstack/react-router'
import { JobFormView } from '@/components/job-form'

export const Route = createFileRoute('/_app/jobs_/$id_/edit')({
  component: function EditJob() {
    const { id } = Route.useParams()
    return <JobFormView jobId={id} />
  },
})
